/**
 * WordPress dependencies
 */
import { BaseControl, HStack } from '@safe-wordpress/components';

/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * Internal dependencies
 */
import { space } from '../wordpress/components/utils';

export const Container = styled.fieldset`
	border: 0;
	margin: 0;
	padding: 0;

	.components-input-control__input {
		height: 40px !important;
		padding-left: calc( 16px ) !important;
		padding-right: calc( 16px ) !important;
	}

	.components-unit-control__select {
		border-radius: 2px !important;
		border: none !important;
		min-width: 24px !important;
		max-width: 48px !important;
		height: 24px !important;
		margin-inline-end: calc( 8px ) !important;
		padding: calc( 4px ) !important;
		color: var(
			--wp-components-color-accent,
			var( --wp-admin-theme-color, #3858e9 )
		) !important;
		font-size: 13px !important;
		white-space: nowrap !important;
		display: flex !important;
		justify-content: center !important;
		align-items: center !important;
		text-transform: none !important;
		width: unset !important;

		:not( :disabled ):hover {
			color: var(
				--wp-components-color-accent,
				var( --wp-admin-theme-color, #3858e9 )
			);
			box-shadow: inset 0 0 0 1px
				var(
					--wp-components-color-accent,
					var( --wp-admin-theme-color, #3858e9 )
				);
			outline: transparent solid 1px;
			background-color: transparent !important;
		}
	}

	.components-unit-control__unit-label {
		min-width: 24px !important;
		max-width: 48px !important;
		height: 24px !important;
		margin-inline-end: calc( 8px ) !important;
		padding: calc( 4px ) !important;
		font-size: 13px !important;
		white-space: nowrap !important;
		display: flex !important;
		justify-content: center !important;
		align-items: center !important;
		text-transform: none !important;
		line-height: normal !important;
	}

	.components-input-control__container[disabled]
		.components-unit-control__unit-label {
		color: var( --wp-components-color-gray-600, #b7b7b7 ) !important;
	}
`;

export const Header = styled( HStack )`
	height: ${ space( 4 ) };
`;

export const HeaderLabel = styled( BaseControl.VisualLabel )`
	display: flex;
	gap: ${ space( 1 ) };
	justify-content: flex-start;
	margin-bottom: 0;
`;
